import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../../common/constants';
import utils from '../../../../common/utils';

export default class FeedbackDetailedLogService extends BaseService {
  constructor() {
    super(constants.GET_FEEDBACK_DETAILED_LOG, constants.FEEDBACK_DETAILED_LOG_STATUS);
  }

  async handleEvent(eventName, event) {
    const { requestId, payload } = event;
    const urlEndpoint = `${constants.FEEDBACK_DETAILED_LOG_ENDPOINT}/${requestId}`;
    const { type, tenantId } = payload || {};
    const requestPayload = { type };
    const headers = tenantId ? { [constants.BERLIN_TENANT_ID_HEADER]: tenantId } : undefined;
    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackbv2').post(urlEndpoint, requestPayload, { headers: enhancedHeaders });
    }
    // Default flow: aiadminv2 with automatic token handling
    return this.getClient('aiadminv2').post(urlEndpoint, requestPayload, { headers });
  }

  handleResponse(response) {
    Framework.getStoreRegistry().getStore('feedbackDetailedLog').setResponse(response.data);
  }

  handleError(error) {
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    }
    Framework.getStoreRegistry().getStore('feedbackDetailedLog').resetStoreValues();
  }
}
